<template>
    <div class="content-box" >
        <div v-if="title !== undefined" class="content-box__header">
            <div class="title">{{ title }}</div>
        </div>
        <div class="content-box__header" v-if="this.$slots.title">
          <slot name="title"/>
        </div>
        <div class="content-box__main">
            <slot name="default" />
        </div>
    </div>
</template>

<script>
export default {
  props: ['title'],
  data() {
    return {
    }
  }
}
</script>
<style lang="stylus" scoped>
.content-box
  background #fff
  border-radius 2px
  overflow hidden
  // box-shadow 0 0 10px 0 rgba(0,0,0,0.85)
  margin-bottom 16px
.content-box__main
  position relative
  margin 16px 24px
.content-box__header
  position relative
  height 53px
  font-size:16px;
  font-weight:500;
  color:rgba(0,0,0,0.85);
  border-bottom 1px solid #E9E9E9
  display flex
 >>>.title
  height:24px;
  line-height:24px;
  padding 16px 0 16px 24px
</style>
